import { NgModule } from 'angular-ts-decorators';

import { SystemDictionaryDirective } from './system-dictionary.directive';

import { TranslationService } from './translation.service';

@NgModule({
  declarations: [SystemDictionaryDirective],
  id: 'gn.audio.public.translation',
  providers: [TranslationService]
})
export class TranslationModule {
}
